import api from './api';

/**
 * Job service for managing construction jobs
 */

export const jobService = {
  /**
   * Get all jobs, optionally filtered by status and search
   */
  getAll: async (status = null, skip = 0, limit = 100, search = null) => {
    const params = { skip, limit };
    if (status) {
      params.status = status;
    }
    if (search) {
      params.search = search;
    }
    const response = await api.get('/jobs', { params });
    return response.data;
  },

  /**
   * Get a single job by ID
   */
  getById: async (jobId) => {
    const response = await api.get(`/jobs/${jobId}`);
    return response.data;
  },

  /**
   * Get the next suggested job number
   */
  getNextJobNumber: async () => {
    const response = await api.get('/jobs/next-job-number');
    return response.data.job_number;
  },

  /**
   * Create a new job
   */
  create: async (jobData) => {
    const response = await api.post('/jobs', jobData);
    return response.data;
  },

  /**
   * Update an existing job
   */
  update: async (jobId, jobData) => {
    const response = await api.put(`/jobs/${jobId}`, jobData);
    return response.data;
  },

  /**
   * Delete a job
   */
  delete: async (jobId) => {
    await api.delete(`/jobs/${jobId}`);
  }
};
